// extracted by mini-css-extract-plugin
export default {"spacePie":"Knob_spacePie__c7uKN","messageError":"Knob_messageError__XhaAN"};